import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Grid, Form, Message } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { Button } from 'semantic-ui-react';
import moment from 'moment';

import { SiteComponent } from 'Common/SiteComponent';
import { TitledCard } from 'Components/';
import { UNCLOSE_DAY_FORM_NAME } from 'Common/FormEnum';
import { UncloseDayEnum as Fields } from 'Common/FieldEnum';
import { DatePickerField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { feedingOptions } from '../helpers';

class UncloseDayFormContainer extends Component {
  currentDate = moment();

  render() {
    const { handleSubmit, loading, getSummaries } = this.props;

    return (
      <div>
        <Form onSubmit={handleSubmit} name={UNCLOSE_DAY_FORM_NAME}>
          <TitledCard title="Utility Settings">
            <Grid columns={1}>
              <Grid.Row>
                <Grid.Column className="input-group--btn-group">
                  <ReduxFormButtonGroup
                    label={'Meal Type'}
                    formName={UNCLOSE_DAY_FORM_NAME}
                    options={feedingOptions}
                    fieldName={Fields.FeedingType}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <SiteComponent
                    name={Fields.Site}
                    {...this.props}
                    isForm={true}
                    isAllRequired={false}
                    loading={this.props.loadingSites}
                    isPrimary={true}
                    selectFirst={true}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Field
                    label={'From Date'}
                    name={Fields.FromDate}
                    component={DatePickerField}
                    type="text"
                    openToDate={this.currentDate}
                    disabled={loading}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <Field
                    label={'To Date'}
                    name={Fields.ToDate}
                    component={DatePickerField}
                    type="text"
                    openToDate={this.currentDate}
                    disabled={loading}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={9}>
                  <div style={{ paddingTop: 15 }}>
                    <Message>
                      <Message.Content>
                        All days that are currently closed within the date range
                        selected will be unclosed.
                      </Message.Content>
                    </Message>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <div
                    style={{
                      marginTop: '12px',
                    }}
                  >
                    <Button onClick={getSummaries}>View Summaries</Button>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
        </Form>
      </div>
    );
  }
}

const validate = (values, props) => {
  var errors = [];

  if (!values[Fields.Site]) {
    errors[Fields.Site] = 'Site must be set.';
  }

  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid Date.';
  }

  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid Date.';
  }

  if (values[Fields.FromDate] === undefined) {
    errors[Fields.FromDate] = 'Enter a valid Date.';
  }

  if (values[Fields.ToDate] === undefined) {
    errors[Fields.ToDate] = 'Enter a valid Date.';
  }

  if (moment(values[Fields.ToDate]).isBefore(values[Fields.FromDate])) {
    errors[Fields.ToDate] =
      'To date must be greater than or equal to from date.';
  }

  return errors;
};

const UncloseDayForm = reduxForm({
  form: UNCLOSE_DAY_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(UncloseDayFormContainer));

export { UncloseDayForm };



// WEBPACK FOOTER //
// ./src/pages/uncloseday/components/UncloseDayForm.js